import { SOURCE_ATTACHMENT, SOURCE_INSPECTION_DOCUMENT, SOURCE_PROPOSAL_DOCUMENT, SOURCE_REPORT } from '../constants';
/**
 * Source filter options.
 *
 * A fixed list rather than one derived from the loaded rows, unlike the file-type filter: the four
 * sources are a closed set defined by `WorkOrders::SupportDocuments`, and a work order that
 * happens to have no proposal documents today should still offer the option — otherwise the filter
 * silently changes shape as rows come and go, which reads as a bug.
 */
export function buildSourceOptions(translateFn) {
    return [SOURCE_ATTACHMENT, SOURCE_REPORT, SOURCE_INSPECTION_DOCUMENT, SOURCE_PROPOSAL_DOCUMENT].map((source) => ({
        value: source,
        label: translateFn(`source.${source}`)
    }));
}
